module.exports = __webpack_public_path__ + "img/violet_031.e9d053a9.png";